import { Injectable } from '@angular/core';
import { DocumentType } from '@wdx/clmi/clmi-swagger-gen';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DocumentsFacadeService } from '../documents-facade';

@Injectable({
    providedIn: 'root',
})
export class DocumentTypesService {
    constructor(private documentsFacadeService: DocumentsFacadeService) {}

    getDocumentTypesFromDocumentTypeCodes(
        documentTypeCodes: string[],
    ): Observable<DocumentType[]> {
        return this.documentsFacadeService
            .getActiveDocumentTypes$()
            .pipe(
                map((docTypes) =>
                    documentTypeCodes
                        ?.map((code) => docTypes.find((dt) => dt.code === code))
                        .filter(Boolean),
                ),
            );
    }
}
